export function customSelect() {
    if ($( "select" ).length) {
        jcf.setOptions("Select", {
            wrapNative: false,
            // wrapNativeOnMobile:false,
            fakeDropInBody: true,
            maxVisibleItems: 8
        });
        jcf.replaceAll();
    }

    if ($(".jcf-scrollable").length) {
        jcf.replaceAll();
    }
}








// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js